export interface IAddress {
    id: string;
    roomNumber?: string;
    floorNumber?: string;
    streetNumber?: string;
    streetName?: string;
    streetType?: string;
    streetSuffix?: string;
    locality?: string;
    city?: string;
    state?: string;
    postcode?: string;
    country?: string
}

export function getAddressFormated(address: string): string {
    if (address !== null || address !== '') {
        const lastWordOfAddress = address.match(/^.*(, .*)$/);
        return lastWordOfAddress && lastWordOfAddress[1] ? (lastWordOfAddress[0].replace(lastWordOfAddress[1], '')).toLowerCase().
            replace(/\b./g, (AddressInLowerCase) => AddressInLowerCase.toUpperCase()) + lastWordOfAddress[1] : address;
    }
}

export function getFullAddress(address: IAddress): string {

    const { roomNumber: roomNumberValue, floorNumber: floorNumberValue } = address;
    const { streetNumber: streetNumberValue, streetName: streetNameValue } = address;
    const { streetSuffix: streetSuffixValue, streetType: streetTypeValue } = address;
    const { city: cityValue, state: stateValue, country: countryValue } = address;

    const slashSeparatedParts = [
        roomNumberValue,
        floorNumberValue
    ];
    const spaceSeparatedParts = [
        streetNumberValue,
        streetNameValue,
        streetSuffixValue,
        streetTypeValue
    ];
    const commaSeparatedParts = [
        cityValue,
        stateValue.toUpperCase(),
        countryValue
    ];

    const slashSeparatedAddressPart = slashSeparatedParts.filter((part) => !!part).join(' / ');
    const spaceSeparatedAddressPart = spaceSeparatedParts.filter((part) => !!part).join(' ');
    const commaSeparatedAddressPart = commaSeparatedParts.filter((part) => !!part).join(', ');
    let fullAddress = [slashSeparatedAddressPart, spaceSeparatedAddressPart, commaSeparatedAddressPart]
        .filter((part) => !!part).join(', ');
    fullAddress = fullAddress ? fullAddress : address.id;
    if (fullAddress.trim().endsWith(',') || fullAddress.trim().endsWith('/')) {
        fullAddress = fullAddress.trim().slice(0, -1);
    }

    return fullAddress;
}
